module.exports = __webpack_public_path__ + "static/media/LC-remarkable.b5e78000.png";